import { Route } from '../Routing/types';
import {
  DietSettingsMealPlanSummary,
  DietSettingsDietType,
  DietSettingsDietLevel,
} from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: '/diet-type',
    private: false,
    title: dummy_t('nutritionSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsDietType />,
  },
  {
    path: '/diet-level',
    private: false,
    title: dummy_t('nutritionSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsDietLevel />,
  },
  {
    path: '/summary',
    private: false,
    title: dummy_t('nutritionSettings.navbarTitle'),
    mobileAppTabIdentifier: 'diet-settings',
    element: <DietSettingsMealPlanSummary />,
  },
];

export default descendantRoutes;
